import { render } from "./PayPal.vue?vue&type=template&id=bed971fe&scoped=true"
import script from "./PayPal.vue?vue&type=script&lang=js"
export * from "./PayPal.vue?vue&type=script&lang=js"

import "./PayPal.vue?vue&type=style&index=0&id=bed971fe&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed971fe"]])

export default __exports__